document.addEventListener("DOMContentLoaded", (event) => {
  const links = document.querySelectorAll("[aria-controls='search-drawer']")
const searchDrawer = document.querySelector("search-drawer")
if (links && searchDrawer){
    links.forEach((link)=>{
        link.addEventListener("click", (event)=>{
            event.preventDefault();
            event.stopPropagation();
            const existingEl = document.querySelector('.boost-sd__search-bar-wrapper');
            if (existingEl) {
                document.querySelectorAll('.boost-sd__search-bar-wrapper').forEach(wrapper => {
                    wrapper.classList.remove('boost-sd__g-hide');
                });
                return;
            }

            const observer = new MutationObserver((mutations, obs) => {
                const el = document.querySelector('.boost-sd__search-bar-wrapper');
                if (el) {
                    document.querySelectorAll('.boost-sd__search-bar-wrapper').forEach(wrapper => {
                        wrapper.classList.remove('boost-sd__g-hide');
                    });
                    obs.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        })
    })
}
});
